import {ReactNode} from 'react';
import {clsx} from 'clsx';

interface Props {
  gridColsClass: string;
  colSpanClass: string;
  children: {
    headerRows?: ReactNode[][] | null | undefined;
    filterRows?: ReactNode[][] | null | undefined;
    body?: ((classNames: string[]) => ReactNode) | null | undefined;
  };
}

export function WhiteTableGrid(props: Props) {
  return <div className={clsx(
    props.gridColsClass,
    'grid',
    'gap-0',
    'border-0',
    'border-b',
    'border-solid',
    'border-whitetable-border',
  )}>
    {
      (props.children.headerRows ?? []).map((headerRow, i) =>
        <div key={i}
             className={clsx(
               props.gridColsClass,
               props.colSpanClass,
               'grid',
               'grid-rows-subgrid',
               'text-2xl!',
             )}>
          {headerRow}
        </div>)
    }

    {
      (props.children.filterRows ?? []).map((filterRow, i) =>
        <div key={i}
             className={clsx(
               props.gridColsClass,
               props.colSpanClass,
               'grid',
               'grid-rows-subgrid',
               'bg-whitetable-header-background',
               'border',
               'border-solid',
               'border-whitetable-border',
               'border-b-0',
             )}>
          {filterRow}
        </div>)
    }

    {(props.children.body ?? null) === null ? null : props.children.body([
      props.gridColsClass,
      props.colSpanClass,
      'grid',
      'grid-rows-subgrid',
      'bg-white',
      'min-h-10',
      'border',
      'border-solid',
      'border-whitetable-border',
      'border-b-0',
    ])}
  </div>;
}
